import React from "react";

function Report({ color = "white"  ,stroke=false}) {
  return (
    <svg
      width="16"
      height="16"
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9524 1H4.04762C2.36447 1 1 2.36447 1 4.04762V9.67331C1 11.3565 2.36447 12.7209 4.04762 12.7209H4.42525C5.22112 12.7209 5.9854 13.0323 6.55474 13.5884L7.46763 14.48C7.76365 14.7691 8.23635 14.7691 8.53237 14.48L9.44526 13.5884C10.0146 13.0323 10.7789 12.7209 11.5747 12.7209H11.9524C13.6355 12.7209 15 11.3565 15 9.67331V4.04762C15 2.36447 13.6355 1 11.9524 1Z"
        stroke={stroke?"currentColor":color}
        strokeWidth="1.5"
      />
      <path
        d="M7.06035 4.45047C7.02766 3.93557 7.43645 3.5 7.95238 3.5C8.46831 3.5 8.87711 3.93557 8.84441 4.45047L8.62753 7.86636C8.60491 8.22262 8.30936 8.5 7.95238 8.5C7.5954 8.5 7.29985 8.22262 7.27723 7.86636L7.06035 4.45047Z"
        fill={color}
          stroke={stroke?"currentColor":color}
      />
      <circle cx="7.95233" cy="10.0236" r="0.761905" fill={color}   stroke={stroke?"currentColor":color} />
    </svg>
  );
}

export default Report;
